import { render, staticRenderFns } from "./RelativeDate.vue?vue&type=template&id=05629785&scoped=true&"
import script from "./RelativeDate.vue?vue&type=script&lang=js&"
export * from "./RelativeDate.vue?vue&type=script&lang=js&"
import style0 from "./RelativeDate.vue?vue&type=style&index=0&id=05629785&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05629785",
  null
  
)

export default component.exports